export enum NavSections {
    public = 1,
    Member = 2, // standard user or any user
    ProjectManager = 4,
    PowerUser = 8,
    OfficeAdmin = 16,
    SecurityAdmin = 32,
    Administrator = 64,
    dataforensics = 128,
    developer = 256
}